import { render, staticRenderFns } from "./AkApprovalStatusSelect.vue?vue&type=template&id=7bb974c2"
import script from "./AkApprovalStatusSelect.vue?vue&type=script&lang=js"
export * from "./AkApprovalStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports